/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 581514dadc99
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  UploadPresetInput,
  UploadPresetInput$zodSchema,
} from "./uploadpresetinput.js";
import {
  UploadPresetMutationResponse,
  UploadPresetMutationResponse$zodSchema,
} from "./uploadpresetmutationresponse.js";

export type UpdateUploadPresetGlobals = { cloud_name?: string | undefined };

export const UpdateUploadPresetGlobals$zodSchema: z.ZodType<
  UpdateUploadPresetGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type UpdateUploadPresetRequest = {
  name: string;
  upload_preset_input: UploadPresetInput;
};

export const UpdateUploadPresetRequest$zodSchema: z.ZodType<
  UpdateUploadPresetRequest
> = z.object({
  name: z.string().describe("The name of the upload preset."),
  upload_preset_input: UploadPresetInput$zodSchema.describe(
    "The updated upload preset configuration.",
  ),
});

export type UpdateUploadPresetResponse =
  | UploadPresetMutationResponse
  | ApiError;

export const UpdateUploadPresetResponse$zodSchema: z.ZodType<
  UpdateUploadPresetResponse
> = z.union([
  UploadPresetMutationResponse$zodSchema,
  ApiError$zodSchema,
]);
